import { request } from '../utils/request';

export const fetchSessionAPI = () => request.get('/admin/session');

export const deleteSessionAPI = id =>
  request.delete(`/admin/session/${id}`);
